
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative h-screen min-h-[900px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6a8c8ae02cf543a6e7340b011145e6c5.jpg"
          alt="Secure Commercial Building"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12 w-full">
        <div className="max-w-3xl">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight uppercase">
            PROTECTING WHAT MATTERS MOST
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-gray-200 mb-10 leading-relaxed">
            Comprehensive security solutions for residential and commercial properties across the Bay Area
          </p>
          <Link
            to="/products"
            className="inline-flex items-center gap-3 sm:gap-4 bg-black text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-medium text-base sm:text-lg hover:bg-gray-900 transition-all group cursor-pointer whitespace-nowrap"
          >
            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-primary flex items-center justify-center">
              <i className="ri-shield-check-line text-white text-lg sm:text-xl"></i>
            </div>
            <span>EXPLORE OUR SOLUTIONS</span>
            <i className="ri-arrow-right-up-line text-lg sm:text-xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
